import { MenuItemIcon } from '@/components/MenuItem/MenuItemIcon';
import Delete from '@/images/Trash.svg';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { deleteElements } from '../../actions/Delete';
import { StyledIconButton } from '../StyledIconButton';

interface Props {
    inPopoverMenu?: boolean;
    closeMenu?: () => void;
}

export const DeleteItem = ({ inPopoverMenu, closeMenu }: Props) => {
    const { store } = useAdvancedEditorContext();
    const selectedElements = store.selectedElements;

    const handleClick = () => {
        closeMenu?.();
        deleteElements(store, selectedElements);
    };

    return (
        <>
            {inPopoverMenu ? (
                <MenuItemIcon onClick={handleClick} src={Delete} text="Delete" />
            ) : (
                <StyledIconButton ariaLabel="delete" src={Delete} onClick={handleClick} />
            )}
        </>
    );
};
